import utils from '../utils';
/**
 * 将url解析成decodeData类型对象
 * @param url 需要解析的url，如果不传则默认当前url
 * @returns decodeData类型对象
 */
function parseURL(url) {
    const protoIndex = url.indexOf('://');
    let temporary = '', protocol = '', hash = '', search = '', hostAndPath = '';
    if (protoIndex > -1) {
        protocol = url.substr(0, protoIndex + 3);
        temporary = url.substr(protoIndex + 3);
    }
    else {
        temporary = url;
    }
    const hashIndex = temporary.indexOf('#');
    if (hashIndex > -1) {
        hash = temporary.substr(hashIndex);
        temporary = temporary.substr(0, hashIndex);
    }
    const searchIndex = temporary.indexOf('?');
    if (searchIndex > -1) {
        search = temporary.substr(searchIndex);
        temporary = temporary.substr(0, searchIndex);
    }
    hostAndPath = temporary;
    return {
        source: url,
        protocol,
        hash,
        search,
        hostAndPath,
    };
}
/**
 * 将search字符串拆解为参数map
 * @param 地址参数search或hash
 * @returns 参数map
 */
function getParams(search) {
    let markIndex = search.indexOf('?');
    let params = {};
    if (markIndex < 0)
        return params;
    let paramStr = search.substr(markIndex + 1);
    let paramArr = paramStr.split('&');
    for (let i = 0; i < paramArr.length; i++) {
        let n = paramArr[i].split('=');
        if (n[0]) {
            params[decodeURIComponent(n[0])] = decodeURIComponent(n[1] || '');
        }
    }
    return params;
}
/**
 * 将参数map根据需求组装成search字符串
 * @param params 参数map
 * @param needEncode 是否需要对参数进行encode
 */
function buildSearch(params, needEncode) {
    let ret = [];
    for (let key in params) {
        if (utils.isVoid(params[key]))
            continue;
        if (needEncode) {
            ret.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
        }
        else {
            ret.push(key + '=' + params[key]);
        }
    }
    return `${ret.length > 0 ? '?' : ''}${ret.join('&')}`;
}
/**
 * 将hash路径返回？之前的路径
 * @param hash 参数map
 */
function buildHashPath(hash) {
    let markIndex = hash.indexOf('?');
    if (markIndex < 0)
        return hash;
    return hash.slice(0, markIndex);
}
/**
 * 将decodeData还原成url
 * @param urlObj
 */
function buildUrl(urlObj) {
    return urlObj.protocol + urlObj.hostAndPath + urlObj.search + urlObj.hash;
}
/**
 * 将decodeData还原成url
 * @param urlObj
 */
function buildHashUrl(urlObj) {
    return urlObj.protocol + urlObj.hostAndPath + urlObj.hash + urlObj.search;
}
/**
 *
 * @param url url地址
 * @param params object
 * @param needEncode 是否需要将参数encode，默认为true
 */
function build(url, params, needEncode = true) {
    let decode = parseURL(url);
    if (decode.search) {
        let origin = getParams(decode.search);
        params = Object.assign(origin, params);
    }
    decode.search = buildSearch(params, needEncode);
    return buildUrl(decode);
}
/**
 *
 * @param url url地址
 * @param params object
 * @param needEncode 是否需要将参数encode，默认为true
 */
function hashBuild(url, params, needEncode = true) {
    let decode = parseURL(url);
    if (decode.hash) {
        let origin = getParams(decode.hash);
        params = Object.assign(origin, params);
        decode.hash = buildHashPath(decode.hash);
    }
    decode.search = buildSearch(params, needEncode);
    return buildHashUrl(decode);
}
/**
 * 获取url中的参数
 * @param url
 */
function query(url) {
    return getParams(parseURL(url).search);
}
/**
 * 获取url中的hash参数
 * @param url
 */
function hashQuery(url) {
    return getParams(parseURL(url).hash);
}
/**
 * 获取url中的hash参数
 * @param url
 */
function removeNineChapterParams(url) {
    if (typeof url !== 'string')
        return '';
    const nineChapterParamsKey = [
        'dchn',
        'prod_key',
        'xbiz',
        'xpsid',
        'xoid',
        // 'openid',
        // 'uid',
        // 'token',
        'xenv',
        // 'lat',
        // 'lng',
        // 'cityid',
        'xspm_from',
        'xpsid_from',
        'xpsid_root',
        'xpsid_share'
    ];
    let decode = parseURL(url);
    if (decode.search) {
        let origin = getParams(decode.search);
        console.log('origin', origin);
        nineChapterParamsKey.forEach(key => {
            if (origin[key])
                delete origin[key];
        });
        decode.search = buildSearch(origin, false);
        if (decode.search === '?')
            decode.search = '';
    }
    return buildUrl(decode);
}
export { build, buildSearch, hashBuild, hashQuery, parseURL, query, removeNineChapterParams };
